module.exports = __webpack_public_path__ + "img/083e7cf.jpg";